export type SyncIndicatorTelemetryState = 'hidden' | 'active' | 'failed' | 'mixed';

export interface SyncIndicatorTelemetryEvent {
    event: 'sync_indicator_state';
    from: SyncIndicatorTelemetryState;
    to: SyncIndicatorTelemetryState;
    mailbox_ids: number[];
    error_class: string | null;
    elapsed_ms: number;
}

const listeners = new Set<(payload: SyncIndicatorTelemetryEvent) => void>();
let stateEnteredAt = Date.now();
let previousState: SyncIndicatorTelemetryState = 'hidden';

export function deriveSyncIndicatorTelemetryState(
    anyActive: boolean,
    anyFailed: boolean,
): SyncIndicatorTelemetryState {
    if (anyActive && anyFailed) {
        return 'mixed';
    }
    if (anyActive) {
        return 'active';
    }
    if (anyFailed) {
        return 'failed';
    }
    return 'hidden';
}

export function subscribeSyncIndicatorTelemetry(
    listener: (payload: SyncIndicatorTelemetryEvent) => void,
): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function resetSyncIndicatorTelemetryForTests(): void {
    listeners.clear();
    previousState = 'hidden';
    stateEnteredAt = Date.now();
}

export function recordSyncIndicatorTransition(
    anyActive: boolean,
    anyFailed: boolean,
    mailboxIds: number[],
    errorClass: string | null,
): void {
    const next = deriveSyncIndicatorTelemetryState(anyActive, anyFailed);
    if (next === previousState) {
        return;
    }
    const payload: SyncIndicatorTelemetryEvent = {
        event: 'sync_indicator_state',
        from: previousState,
        to: next,
        mailbox_ids: mailboxIds,
        error_class: errorClass,
        elapsed_ms: Date.now() - stateEnteredAt,
    };
    previousState = next;
    stateEnteredAt = Date.now();
    listeners.forEach((listener) => listener(payload));
}
